import {Image, ImageBackground, Text, View} from 'react-native';
import React from 'react';
import {useTheme} from 'contexts/ThemeContext';
import styleSheet from './styles';
import strings from '../../../translations';
import SignInWithGoogleButton from '../signInWithGoogleButton';
import {useWindowDimensions} from 'react-native';
import {DEVICE_SIZES} from 'rn-responsive-styles';
import {getSize} from 'helpers/getSize';

interface ILogin {
  onPress(): void;
}

const Login: React.FC<ILogin> = ({onPress}) => {
  const styles = styleSheet(useTheme());
  const theme = useTheme();
  const width = useWindowDimensions().width;

  const ContentView = (
    <View style={styles.contentContainerWeb}>
      <Image
        style={styles.logoWebStyle}
        source={theme.images.appIcon}
        resizeMode="contain"
      />
      <Text style={styles.titleStyle}>{strings.loginScreen.title}</Text>
      <Text style={styles.subTitleStyle}>{strings.loginScreen.subTitle}</Text>
      <SignInWithGoogleButton onPress={onPress} />
    </View>
  );

  return (
    <ImageBackground
      source={theme.images.signInBackground}
      style={styles.containerWeb}>
      {ContentView}
      {width > getSize(DEVICE_SIZES.LARGE_DEVICE) && (
        <Image
          resizeMode="contain"
          style={styles.heroImageWeb}
          source={theme.images.heroImageLoginScreen}
        />
      )}
    </ImageBackground>
  );
};

export default Login;
